/* eslint-disable import/prefer-default-export */
export enum SubscriptionFrequency {
  monthly = 'monthly',
  annually = 'annually',
  onetime = 'onetime',
}
